// Mock data extracted from original App.js
// 本文件只放演示数据和字典配置，不放页面 JSX。
// 产品侧改字段时，可以先在这里补数据，再去对应 pages 文件里展示。

// ================= 学生综合测评基础数据 =================
export const mockStudents = [
  {
    id: 1, studentId: '2102001', name: '陈红', college: '计算机学院', major: '软件工程', grade: '2021级', className: '计算机1班',
    studyScore: 85.50, peerScore: 4.80, teacherScore: 5,
    mandatoryScore: { de: 28, zhi: 14, ti: 7, mei: 7, lao: 7 },
    bonusScore: { de: 5, zhi: 2, ti: 0.5, mei: 0.5, lao: 0.5 },
    bonusDetails: {
      de: [{ name: '获得校级“优秀共青团员”称号', score: 3, date: '2025-10-12' }, { name: '参与迎新志愿服务满20小时', score: 2, date: '2025-09-05' }],
      zhi: [{ name: '全国大学生数学建模省二等奖', score: 2, date: '2025-11-20' }]
    },
    deduction: 0, deductionDesc: '',
    totalScore: 77.66, status: 'normal'
  },
  {
    id: 2, studentId: '2102002', name: '林峰', college: '计算机学院', major: '软件工程', grade: '2021级', className: '计算机2班',
    studyScore: 92.00, peerScore: 4.50, teacherScore: 4,
    mandatoryScore: { de: 25, zhi: 12, ti: 6, mei: 5, lao: 6 },
    bonusScore: { de: 6, zhi: 3, ti: 0, mei: 1, lao: 0 },
    bonusDetails: {
      de: [{ name: '见义勇为受校级表彰', score: 6, date: '2025-12-01' }],
      zhi: [{ name: '软著第一发明人', score: 3, date: '2025-10-15' }],
      mei: [{ name: '校园十佳歌手亚军', score: 1, date: '2025-11-11' }]
    },
    deduction: -5, deductionDesc: '晚归违纪一次，通报批评',
    totalScore: 82.96, status: 'outdated'
  },
];

// 综合素质评分的五类指标字典。
// title：页面展示名称；totalMax/manMax/bonMax：满分配置；desc：抽屉中展示的评分说明。
export const indicatorDict = {
  de: {
    title: '德育素质',
    totalMax: 40,
    manMax: 28,
    bonMax: 12,
    desc: [
      '1. 拥护中国共产党的领导，认真学习党的基本理论、基本路线、基本方针。',
      '2. 有较强的组织纪律观念、关心同学、注重团结协作。',
      '3. 具有较强的法治观念，遵守校纪校规，无违纪行为。',
      '4. 良好的生活状态与积极向上的精神风貌。',
    ],
    manDesc: '理想信念坚定，遵纪守法，集体观念强，日常表现良好。',
    bonusCats: [
      {
        name: '理论学习类',
        items: [
          { name: '参与“青年大学习”等线上主题团课', needProof: '无', itemScore: 1, countLimit: 2, scoreLimit: 2 },
          { name: '利用“学习强国”等平台自觉开展理论学习', needProof: '文字说明', itemScore: 1, countLimit: '-', scoreLimit: 2, textLimit: 100 },
        ],
      },
      {
        name: '实践培训类',
        items: [
          { name: '参加校(院)级青年马克思主义学校等培训班并结业', needProof: '附件', itemScore: 2, countLimit: 1, scoreLimit: 2 },
          { name: '获得校级“优秀共青团员”等荣誉称号', needProof: '附件', itemScore: 3, countLimit: 1, scoreLimit: 3 },
        ],
      },
    ],
  },
  zhi: {
    title: '智育素质',
    totalMax: 20,
    manMax: 14,
    bonMax: 6,
    desc: [
      '1. 学习目的明确，学习态度端正，勤奋好学，刻苦钻研。',
      '2. 积极参与教学活动，努力掌握基础理论、专业知识和基本技能。',
    ],
    manDesc: '学习态度端正，课堂参与良好，能够完成专业培养要求。',
    bonusCats: [
      {
        name: '竞赛成果类',
        items: [
          { name: '参加学科竞赛并获得校级及以上奖项', needProof: '附件', itemScore: 2, countLimit: 2, scoreLimit: 4 },
          { name: '发表论文、专利、软著等学术成果', needProof: '附件', itemScore: 3, countLimit: 1, scoreLimit: 3 },
        ],
      },
    ],
  },
  ti: {
    title: '体育素质',
    totalMax: 10,
    manMax: 7,
    bonMax: 3,
    desc: [
      '1. 积极参加课内外体育锻炼，养成良好的运动习惯。',
      '2. 达到《国家学生体质健康标准》相关要求。',
    ],
    manDesc: '积极参加体育锻炼，体质健康测试和体育课程表现达标。',
    bonusCats: [
      {
        name: '体育竞赛类',
        items: [
          { name: '参加校级及以上体育竞赛并获奖', needProof: '附件', itemScore: 1, countLimit: 3, scoreLimit: 3 },
        ],
      },
    ],
  },
  mei: {
    title: '美育素质',
    totalMax: 10,
    manMax: 7,
    bonMax: 3,
    desc: [
      '1. 具有健康的审美情趣，自觉提升审美修养。',
      '2. 积极参加各类文化艺术普及活动。',
    ],
    manDesc: '具有良好审美素养，积极参加文化艺术活动。',
    bonusCats: [
      {
        name: '美育活动类',
        items: [
          { name: '参加校级及以上文艺活动、展演或比赛并获奖', needProof: '附件', itemScore: 1, countLimit: 3, scoreLimit: 3 },
        ],
      },
    ],
  },
  lao: {
    title: '劳育素质',
    totalMax: 10,
    manMax: 7,
    bonMax: 3,
    desc: [
      '1. 树立正确的劳动观，尊重劳动人民。',
      '2. 积极参加志愿服务、勤工助学及日常宿舍/教室劳动清洁。',
    ],
    manDesc: '尊重劳动，积极参加日常劳动、志愿服务和实践活动。',
    bonusCats: [
      {
        name: '劳动实践类',
        items: [
          { name: '参加志愿服务、劳动实践活动并达到规定时长', needProof: '附件', itemScore: 1, countLimit: 3, scoreLimit: 3 },
        ],
      },
    ],
  },
};

// 求和工具：多个页面都会用到“必选项合计、加分合计”。
export const sumObj = (obj) => Object.values(obj).reduce((a, b) => a + Number(b || 0), 0);
